import { useMultiSelectFilter } from '@/scopes/search/search/domain/hooks'
import { Token } from '@sunwebgroup/ui-components/uds'

import { equals, reject } from 'ramda'
import * as React from 'react'

export function MealPlanTokens() {
  const { isFetching, isLoading, selectedOptions, setSelection, selectedValues } = useMultiSelectFilter('Mealplan')

  const handleRemoveClick = React.useCallback(
    (value?: string) => {
      setSelection(reject(equals(value), selectedValues))
    },
    [selectedValues, setSelection],
  )

  if (isLoading)
    return null

  return selectedOptions.map(({ value, name }) => (
    <Token key={value} value={value} disabled={isFetching} dismissible onDismissClick={handleRemoveClick}>
      {name}
    </Token>
  ))
}
